import { h, Component } from 'preact';
import { Link } from 'components/core/link/link.js';
import { sortObjectByOrder, joinClasses } from 'utils/utils';
import s from 'components/shared/dropdown/dropdown.sss';


export default class Dropdown extends Component {

	toggleOpen = () => {
		this.setState({ open: !this.state.open });
	};

	render(props, state) {
		const {
			childrenObj,
			appData,
			title,
			sideNavActive,
			pageId,
			wrapperClass,
			dropdownClass,
			pages,
			revealOnHover,
			useAbsolute,
			iconStyle
		} = props;

		const { copy } = appData;

		const pClass = joinClasses(s.parent, wrapperClass, revealOnHover && s.onHover, state.open && s.open, useAbsolute && s.absolute, sideNavActive && s.sideNav, iconStyle && s.iconNudge);

		const titleText = copy[title] || title;
		let titleElem = <div class={s.title} onClick={!revealOnHover && this.toggleOpen}>{titleText}</div>;
		if (pageId) {
			titleElem = <Link class={joinClasses(s.title, s.linkTitle)} pageId={pageId}>{titleText}</Link>;
		}
		return (
			<div class={pClass} style={iconStyle}>
				{titleElem}
				<ul class={s.wrapper}>
					{sortObjectByOrder(childrenObj, navItem => {
						const pageId = navItem.id;
						let childProps;
						let text;

						let page = pages[pageId];
						if (page) {
							childProps = {
								pageId
							};
							text = copy[page.$copy] || page.$copy;
						} else {
							childProps = {
								href:    navItem.link,
								trackId: navItem.trackId,
								target:  navItem.target
							};
							text = copy[navItem.$copy] || navItem.$copy;
						}
						return (
							<li>
								<Link
									class={dropdownClass}
									{...childProps}
								>
									{text}
								</Link>
							</li>
						);
					})}
				</ul>
			</div>
		);
	}

}
